import { call, put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import { IHttpError } from "types/http";
import ZnsTemplateService from "modules/outbound-message/services/znsTemplateService";
import { IZnsTemplateListParams } from "../types/znsTemplate";
import {
  IZnsTemplatesData,
  loadZnsTemplates,
  loadZnsTemplatesSuccess,
  loadZnsTemplatesFailed,
  syncZnsTemplates,
  syncZnsTemplatesSuccess,
  syncZnsTemplatesFailed,
} from "./znsTemplateSlice";

/**
 * Saga worker: fetches ZNS templates list and dispatches success or failure.
 */
function* handleLoadZnsTemplates(
  action: PayloadAction<IZnsTemplateListParams>
): Generator {
  try {
    const data = (yield call(
      ZnsTemplateService.getZnsTemplates,
      action.payload
    )) as IZnsTemplatesData;
    yield put(loadZnsTemplatesSuccess(data));
  } catch (error) {
    yield put(loadZnsTemplatesFailed(error as IHttpError));
  }
}

/**
 * Saga worker: triggers sync from Zalo OA and dispatches success or failure.
 */
function* handleSyncZnsTemplates(): Generator {
  try {
    yield call(ZnsTemplateService.syncZnsTemplates);
    yield put(syncZnsTemplatesSuccess());
  } catch (error) {
    yield put(syncZnsTemplatesFailed(error as IHttpError));
  }
}

export default function* znsTemplateSaga() {
  yield takeLatest(loadZnsTemplates.toString(), handleLoadZnsTemplates);
  yield takeLatest(syncZnsTemplates.toString(), handleSyncZnsTemplates);
}
